import { FormControlLabel, FormControlLabelProps, Switch, Theme, Typography } from '@mui/material';
import { styled, SystemStyleObject } from '@mui/system';
import { FC } from 'react';

type MarkbookSettingsSwitchProps = {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
} & Omit<FormControlLabelProps, 'control' | 'onChange'>;

export const MarkbookSettingsSwitch: FC<MarkbookSettingsSwitchProps> = ({
  label,
  value,
  onChange,
  sx,
  ...props
}) => {
  return (
    <MarkbookSettingsSwitchStyled
      checked={!!value}
      control={
        <Switch
          checked={value}
          onChange={(e) => {
            onChange(e.target.checked);
          }}
        />
      }
      label={<Typography variant="h3">{label}</Typography>}
      sx={(theme: Theme) => ({
        m: 0,
        ...((typeof sx === 'function' ? sx(theme) : sx) as SystemStyleObject),
      })}
      {...props}
    />
  );
};

const MarkbookSettingsSwitchStyled = styled(FormControlLabel)(({ theme, checked }) => ({
  '& .MuiTypography-root': {
    color: checked ? undefined : theme.palette.common.grey,
  },
  '&:hover:not(.Mui-disabled)': {
    '& .MuiTypography-root': {
      color: theme.palette.primary.main,
    },
    '& .MuiSwitch-track': {
      opacity: 1,
    },
  },
  '&.Mui-disabled': {
    '& .MuiTypography-root': {
      color: theme.palette.common.main5,
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: theme.palette.background.paper,
    },
    '&& .MuiSwitch-track': {
      borderColor: theme.palette.common.grey6,
      backgroundColor: theme.palette.common.grey6,
      opacity: 1,
    },

    '&& .Mui-checked+.MuiSwitch-track': {
      backgroundColor: theme.palette.background.paper,
      borderColor: theme.palette.common.main5,
      opacity: 1,
    },
    '& .Mui-checked .MuiSwitch-thumb': {
      backgroundColor: theme.palette.common.main5,
    },
  },
}));
